<main class="projects-timeline" #timeline>
  <projects-timeline-header [fullCalendar]="fullCalendarComponent" #timelineHeaderComponent />
  <div class="projects-timeline__calendar" #calendarContainer>
    <full-calendar [options]="calendarOptions" #fullCalendarComponent />
  </div>
</main>
